const _store = {
  getState() {
    return _store.store?.getState();
  },
  dispatch(...args) {
    return _store.store?.dispatch(...args);
  }
}
export { _store }